import {
  createThreadBehaviour,
  type ResponderDraftEvent,
} from './shared-responder-v2-core-thread-behaviour';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';
import type { ResponderAnswer } from './shared-responder-v2-core-thread.types';

export function emptyContactInfoDraft(): ResponderAnswer {
  return { kind: 'text', text: '', transcript: null };
}

export function reduceContactInfoDraft(
  draft: ResponderAnswer | null,
  event: ResponderDraftEvent
): ResponderAnswer | null {
  if (event.type === 'textChanged') {
    return {
      kind: 'text',
      text: event.text,
      transcript: draft?.kind === 'text' ? draft.transcript : null,
    };
  }

  if (event.type === 'transcriptChanged') {
    return {
      kind: 'text',
      text: draft?.kind === 'text' ? draft.text : '',
      transcript: event.transcript,
    };
  }

  return draft;
}

export function isContactInfoDraftComplete(
  draft: ResponderAnswer | null
): boolean {
  if (draft?.kind !== 'text') {
    return false;
  }

  const hasText = draft.text.trim() !== '';
  const hasTranscript =
    draft.transcript !== null && draft.transcript.trim() !== '';

  return hasText || hasTranscript;
}

/**
 * A contact-info question is an open-ended question tagged `internal:contact`
 * rather than its own GraphQL type, so its draft model is the plain `text`
 * shape and it shares the composer-owned input model with open-ended.
 */
export const CONTACT_INFO_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.ContactInfo,
  answersInComposer: true,
  surfaceInputIsComposer: true,
  emptyDraft: emptyContactInfoDraft,
  reduceDraft: reduceContactInfoDraft,
  isDraftComplete: isContactInfoDraftComplete,
});
